module.exports = __webpack_public_path__ + "static/media/Si-ordet-en-gang-til.6a245a52.mp3";